import React, { Component } from "react";
import PageTitle from "../Theme/PageTitle";
import { Table, Modal, Button } from "antd";
import DashboardLayout from "../Theme/DashboardLayout";
import moment from 'moment';
import _ from 'underscore';
import Spinner from '../Theme/Spinner';
import trueBlankDayTypeRequest from './utils/day-type-requests/trueBlankDayTypeRequest';
import DayTypeRequestUpdate from './DayTypeRequestsUpdate';
import SelectDayTypeResourceButton from './SelectDayTypeResource/SelectDayTypeResourceButton';
import * as dayTypeActions from '../../redux/actions/dayTypeActions';
import * as resourceActions from '../../redux/actions/resourceActions';
import { bindActionCreators } from "redux";
import AuthLogic from '../../AuthLogic';
import { connect } from 'react-redux';

class DayTypeCalendarView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widescreen: false,
      resource: '',
      dayTypeRequests: [],
      selectedDayTypeRequest: {},
      contextMenuKey: false,
      dayTypeDetailModal: false,
      dayTypeTable: {
        columns: [
          {
            title: 'Day type',
            dataIndex: 'dayTypeName',
            render: text => <a>{text}</a>
          },
          {
            title: 'From Date',
            dataIndex: 'fromDate',
            render: text => <a>{moment(text).format('MM/DD/YYYY')}</a>
          },
          {
            title: 'To Date',
            dataIndex: 'toDate',
            render: text => <a>{moment(text).format('MM/DD/YYYY')}</a>
          },
          {
            title: 'Status',
            dataIndex: 'status',
            render: text => <a>{text}</a>
          }
        ]
      },
      loaded: false
    }
  }

  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.readyApiCall();
  }

  readyApiCall = () => {
    let resource = {
      id: this.props.selectedDayTypeResource.id || this.props.user.login.resourceId,
      name: this.props.selectedDayTypeResource.name || this.props.user.userDemographics.name
    }
    this.setState({
      resource,
      loaded: false
    }, () => {
      console.log(`resourceName: ${this.state.resource.name}, resourceId: ${this.state.resource.id}`);
      this.getDataFromApi();
    });
  }

  getDataFromApi = async () => {
    const resourceId = this.state.resource.id || this.props.user.login.resourceId;
    const year = parseInt(moment().format('YYYY'));
    const month = parseInt(moment().format('M'));
    const isApprover = AuthLogic.isApprover(this.props.user);
    let hasError = false;

    await this.props.actions.fetchDayTypesAll(isApprover, this.state.resource.id, moment().format('YYYY-MM-DD'))
    .catch(error => {
      if (!_.isEmpty(error)) {
        hasError = true;
        alert("Your STORM Resource account is not set up correctly; please contact the STORM Team.");
      }
    });

    if (hasError) {
      this.setState({loaded: true});
      return;
    }

    await this.props.actions.fetchDayTypeRequestsByYear(resourceId, year, month)
      .catch(error => {
        console.log(error);
        alert("Your STORM Resource account is not set up correctly; please contact the STORM Team.");
      });
    this.setState({
      dayTypeRequests: await this.props.dayTypeRequests,
      loaded: true
    });
  }

  selectDayType = async (dayType) => {
    await this.props.actions.fetchDayTypeRequestById({ id: dayType.dayTypeRequestId });

    let dayTypeRequestInfo = this.props.dayTypeRequestInfo[0];
    let combinedDayType = { ...dayType };
    combinedDayType.fromTime = dayTypeRequestInfo.fromTime;
    combinedDayType.toTime = dayTypeRequestInfo.toTime;
    combinedDayType.status = dayTypeRequestInfo.status

    this.setState({
      selectedDayTypeRequest: await combinedDayType
    }, () => {
      this.showModal();
    })
  }

  resize = () => {
    if (window.innerWidth >= 990) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  showCreateModal = () => {
    this.setState({
      contextMenuKey: true,
      selectedDayTypeRequest: {...trueBlankDayTypeRequest}
    }, () => {
      this.setState({
        dayTypeDetailModal: true
      });
    })
  }

  showModal = () => {
    this.setState({
      contextMenuKey: false
    }, () => {
      this.setState({
        dayTypeDetailModal: true
      });
    })
  }

  handleModalCancel = (e) => {
    this.setState({
      dayTypeDetailModal: false,
    });
  }

  render() {
    return (
      <DashboardLayout>
        <PageTitle title={'Day Type Requests'} subTitle={this.state.resource.name || this.props.user.userDemographics.name} />
        {this.state.loaded
          ?
          <React.Fragment>
            <Table
              columns={this.state.dayTypeTable.columns}
              dataSource={this.state.dayTypeRequests}
              size='small'
              scroll={{ y: 240 }}
              pagination={{
                total: this.state.dayTypeRequests.length,
                pageSize: this.state.dayTypeRequests.length,
                hideOnSinglePage: true
              }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => { this.selectDayType(record) }
                };
              }}
            />

            {(AuthLogic.addDayTypeRequest(this.props.user) && this.props.user.mobileSecurity.canEdit==3 ) && (
              <Button style={{ marginTop: 20 }} type="primary" size={'large'} htmlType="submit" onClick={this.showCreateModal}>
                Create Day Type Request
              </Button>
            )} 

            <Modal
              zIndex={2000}
              title={'Day Type Request'}
              visible={this.state.dayTypeDetailModal}
              onCancel={this.handleModalCancel} // the x in top right corner
              footer={[]}
            >
              <DayTypeRequestUpdate
                readyApiCall={this.readyApiCall}
                selectedDayTypeRequest={this.state.selectedDayTypeRequest}
                handleModalCancel={this.handleModalCancel}
                contextMenuKey={this.state.contextMenuKey}
              />
            </Modal>
          </React.Fragment>
          :
          <Spinner />
        }
        { AuthLogic.changeAbsencesResource(this.props.user) &&
          (<SelectDayTypeResourceButton
            updatePageCallback={this.readyApiCall}
          />)
        }
      </DashboardLayout>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    resources: state.resources,
    selectedDayTypeResource: state.selectedDayTypeResource,
    dayTypeRequests: state.dayTypeRequestsByYear.dayTypeRequestsArray,
    dayTypeRequestInfo: state.dayTypeRequestInfo,
    ifHasHolidaySchedule: state.ifHasHolidaySchedule
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchDayTypeRequestsByYear: bindActionCreators(
        dayTypeActions.fetchDayTypeRequestsByYear,
        dispatch
      ),
      fetchDayTypeRequestById: bindActionCreators(
        dayTypeActions.fetchDayTypeRequestById,
        dispatch
      ),
      fetchDayTypesAll: bindActionCreators(
        dayTypeActions.fetchDayTypesAll,
        dispatch
      ),
      addDayType: bindActionCreators(
        dayTypeActions.createDayType,
        dispatch
      ),
      updateSelectedDayTypeResource: bindActionCreators(
        resourceActions.updateSelectedDayTypeResource,
        dispatch
      ),
      fetchIfHasHolidaySchedule: bindActionCreators(
        dayTypeActions.fetchIfHasHolidaySchedule,
        dispatch
      ),
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DayTypeCalendarView);



// WEBPACK FOOTER //
// ./src/Components/DayType/DayTypeRequestsView.js